import React, { FC } from 'react';
import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';
import { LawyerIcon } from '../../components/entities-card/icons/LawyerIcon';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const LawyerCardTitle: FC<Props> = ({ children, ...props }) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle icons={LawyerIcon}>{children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
